<div class="dialogContainer">
  <div class="content">
    {{ message }}
  </div>
  <div class="buttonBar">
    <span class="spacer"></span>
    <button class="primary-button" matButton="elevated" (click)="close()">OK</button>
    <span class="spacer"></span>
  </div>
</div>
